/**
 * @file Album folder discovery related constants.
 */

const ALBUM_LENGTH_DROPDOWN_CONVERSION = 15;

/**
 * @enum PPGD_JOIN_TYPE
 * @type {{PURCHASE: string, JOIN: string}}
 */
const PPGD_JOIN_TYPE = {
  PURCHASE: 'PURCHASE',
  JOIN: 'JOIN',
};

export { ALBUM_LENGTH_DROPDOWN_CONVERSION, PPGD_JOIN_TYPE };
